import React from "react";
import Loader from '../../../../components/Loader';
import Page from '../../../../components/Page';
import HTTPManager from "../../../../utils/httpRequestManager"; 
import { toast, ToastContainer } from 'react-toastify'; 
import {Box, Grid,   Container, Typography, Stack, InputAdornment} from '@mui/material';

import FTextField from "../../../../components/formComponents/components/textField";
import FButton from "../../../../components/formComponents/components/button";
// import FSelect from "../../../../components/formComponents/components/select";
import { checkButtonAccess  } from "../../../../utils/protector";
export default class CommissionPayment extends React.Component{
    httpManager = new HTTPManager();

    constructor(){
        super();
        this.state={
            isLoading:true, 
            addForm: false, 
            settings:[
                {
                    minimumTicketValue:'',
                    dollarSpent:'',
                    pointsCount:'',
                    settingType:'General'
                }
            ],
            settingType:[
                {
                    label:"General",
                    value:"General"
                },
                {
                    label:"Birthday",
                    value:"Birthday"
                },
                {
                    label:"Others",
                    value:"Others"
                }
            ],
            isDisabled:false
        }  

        this.changeValue = this.changeValue.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }  

    submitForm(){
        this.httpManager.postRequest('merchant/lpsettings/saveRedeemSettings', {settings: Object.assign([], this.state.settings)}).then(res=>{
            this.reloadData();
        })
    }

    componentDidMount(){   
            this.reloadData(); 
    } 
    reloadData(msg=''){
        if(msg !== ''){ 
            toast.dismiss();
            toast.success(msg, {
                position: "top-center",
                autoClose: 5000,
                closeButton:false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
        this.setState({isLoading: true, addForm: false},()=>{
            this.httpManager.getRequest(`merchant/lpsettings/getRedeemSettings`).then(response=>{ 
                // this.openEdit(response.data); 
                if(response.data.length > 0){
                    this.setState({settings: response.data, isLoading: false }, ()=>{
                        
                    });
                }
                else{
                    this.setState({isLoading: false})
                }
            })
        })
    }
    changeValue(e, i){
        var settings = Object.assign([], this.state.settings);

        var obj = settings[i];
        obj[e.target.name] = e.target.value;
        settings[i] = obj;

        this.setState({settings: settings})
    }
    renderForm(){
        var fields = [];
        this.state.settings.forEach((elmt, i)=>{
        fields.push(<>
 
                    <Grid item xs={4}>
                        <FTextField autoFocus={true} defaultValue='aaa' InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }} required={true} fullWidth  error={elmt.error} helperText={elmt.helperText} type={'text'} format={'number'} minLength={1} maxLength={4}  label={'Every $ Spent'} placeholder={'Every $ Spent'} name={'dollarSpent'} value={this.state.settings[i].dollarSpent}   onChange={e=>{
                             this.changeValue(e,i)
                        }} disabled={checkButtonAccess('LoyaltyPoints')==='R'}/>
                    </Grid>   
                    <Grid item xs={4}>
                        <FTextField  tabindex={i+1} disabled={checkButtonAccess('LoyaltyPoints')==='R'} required={true} fullWidth  error={elmt.error} helperText={elmt.helperText} type={'text'} format={'numberdecimal'} minLength={1} maxLength={4}  label={'Points'} placeholder={'Points'} name={'pointsCount'} value={this.state.settings[i].pointsCount}   onChange={e=>{
                             this.changeValue(e,i)
                        }}/>
                    </Grid>   
                    <Grid item xs={4}>
                        <FTextField tabindex={i+1} disabled={checkButtonAccess('LoyaltyPoints')==='R'} required={true} fullWidth  error={elmt.error} helperText={elmt.helperText} type={'text'} format={'number'} minLength={1} maxLength={6}  label={'Min. Ticket Value'} placeholder={'Min. Ticket Value'} name={'minimumTicketValue'} value={this.state.settings[i].minimumTicketValue}   onChange={e=>{
                             this.changeValue(e,i)
                        }}/>
                    </Grid> 
                    
            </>)
        })

        var buttons = this.renderButtons();
        fields.push(buttons)
        return fields;
    }

    renderButtons(){
        var detail = window.localStorage.getItem('userdetail')
        if(detail !== '' && detail !== undefined && detail !=='{}'){
          var userdetail = JSON.parse(detail);
            return <Grid container style={{marginTop:'1rem', marginLeft:'1rem', display:'flex', alignItems:'center', justifyContent:'center'}}>
                <Grid item xs={2}> 
                    {(checkButtonAccess('LoyaltyPoints') === 'W' || userdetail.userRole === 'Owner') && <FButton fullWidth size="large" variant={'contained'} disabled={this.state.isDisabled} label={"Save"} onClick={()=>{
                        this.submitForm()
                    }
                    }/>} 
                </Grid>
            </Grid>
        }
    }

    render(){
        return <Page title="Loyalty Points Redeem Settings | Astro POS">
            {this.state.isLoading && <Loader show={this.state.isLoading} />}
            <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            />
            <Container maxWidth="xl">
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                    <Typography variant="h4" gutterBottom>
                        Loyalty Point Settings 
                    </Typography>
                    
                </Stack>
                <Box sx={{ width: '100%' }}> 
                <Grid container spacing={3}  alignItems="center"  justifyContent="center" style={{marginLeft:0,marginTop:'1rem', marginRight:0,width:'100%', fontWeight:'bold'}} > 
                       <div className="formContainer">
                            <form name={this.state.formName} className={this.state.formClass !== undefined ? this.state.formClass : ''}>
                                <Grid container spacing={3}  alignItems="center"  justifyContent="center" className='formGrid' > 
                                    {this.renderForm()}
                                </Grid>
                            </form>
                        </div>  
                </Grid>

                </Box>
            </Container>
        </Page>
    }

}